export const titleText = {
  sec1: { title: 'CURRENT STATUS' },
  sec2: {
    title: 'DriverPerformance',
    subTitle: { sub1: 'Delivery Status', sub2: 'Current Status In Hours', sub3: 'Success Order In Hours' }
  },
  sec3: {
    title: 'OrderPerformance'
  }
}
